import React from 'react';
import { useSelector } from 'react-redux';
import sortByProp from '../../../lib/sortByProp.js';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';

const PipelineStatusEditorDetails = ({ state = {}, onChange = () => {} }) => {
  const pipelineLeadStatuses = useSelector((state) => state.app.pipeline_lead_statuses) || [];

  const status = pipelineLeadStatuses.find((n) => n.id === state.statusId);
  const subStatus = ((status || {}).sub_statuses || []).find((n) => n.id === state.subStatusId);

  const safariStatusDate = typeof state.statusDate === 'string' ? (state.statusDate || '').replace(/-/g, '/') : state.statusDate;

  const handleFormChange = (e, key) =>
    onChange({
      ...state,
      [key]: e.target.value,
    });

  const handleDateChange = (date) => {
    onChange({ ...state, statusDate: format(date, 'yyyy-MM-dd HH:mm:ss') });
  };

  const handleSubStatusClick = (e, subStatus) => {
    e.preventDefault();
    onChange({ ...state, subStatusId: state.subStatusId === subStatus.id ? null : subStatus.id });
  };

  return (
    <div className={`status-content ${String((status || {}).status).toLowerCase() || ''}`}>
      {status && (
        <div className="quick-edit-tabs-item">
          <div className="subheading">{status.status === 'Active' ? 'Select status:' : 'Select reason:'}</div>
          <ul className={`status-${status.status.toLowerCase()}`}>
            {(status.sub_statuses || []).sort(sortByProp('id')).map((n) => (
              <li key={n.id} className={`status-${n.sub_status.toLowerCase()} ${subStatus && n.sub_status === subStatus.sub_status ? 'is-active' : ''}`} onClick={(e) => handleSubStatusClick(e, n)}>
                {n.sub_status}
              </li>
            ))}
          </ul>
          {status.status !== 'Active' && (
            <Form.Group className="elevated">
              <Form.Label>Date {status.status === 'Won' ? 'Won' : 'Lost'}:</Form.Label>
              <DatePicker selected={safariStatusDate ? new Date(safariStatusDate) : new Date()} onChange={handleDateChange} />
            </Form.Group>
          )}
          {status.status !== 'Active' && (
            <Form.Group>
              <Form.Label>Note:</Form.Label>
              <Form.Control size="sm" onChange={(e) => handleFormChange(e, 'note')} value={state.note || ''} />
            </Form.Group>
          )}
        </div>
      )}
    </div>
  );
};

export default PipelineStatusEditorDetails;
